import { render, staticRenderFns } from "./SFGrid.vue?vue&type=template&id=2e45886f&lang=pug&"
import script from "./SFGrid.vue?vue&type=script&lang=ts&"
export * from "./SFGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SFGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports